__turbopack_context__.v({
  "className": "oswaldfont_3636ff9e-module__VbxgVq__className",
  "variable": "oswaldfont_3636ff9e-module__VbxgVq__variable",
});
